import React from 'react';

const PricingForm = ({
  showForm,
  setShowForm,
  editingId,
  formData,
  onInputChange,
  onSubmit,
  onReset,
  saving,
}) => (
  <>
    <div className="flex justify-between items-center mb-4">
      <h2 className="font-display text-lg font-semibold text-heading">
        {showForm ? (editingId ? 'Edit Pricing' : 'Add Pricing') : 'Pricing Configuration'}
      </h2>
      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="btn-clay flex items-center"
        >
          <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Pricing
        </button>
      )}
    </div>

    {showForm && (
      <div className="card-clay p-6 mb-6">
        <form onSubmit={onSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label htmlFor="pricing-provider" className="block text-sm font-medium text-body-text mb-1">Provider</label>
              <select
                id="pricing-provider"
                name="provider"
                value={formData.provider}
                onChange={onInputChange}
                required
                className="input-clay"
              >
                <option value="">Select provider</option>
                <option value="openai">OpenAI</option>
                <option value="gemini">Gemini</option>
                <option value="anthropic">Anthropic</option>
                <option value="vertex_ai">Vertex AI</option>
              </select>
            </div>
            <div>
              <label htmlFor="pricing-model" className="block text-sm font-medium text-body-text mb-1">Model</label>
              <input
                id="pricing-model"
                type="text"
                name="model"
                value={formData.model}
                onChange={onInputChange}
                required
                placeholder="e.g., gpt-4o-mini"
                className="input-clay"
              />
            </div>
            <div>
              <label htmlFor="pricing-effective-from" className="block text-sm font-medium text-body-text mb-1">Effective From</label>
              <input
                id="pricing-effective-from"
                type="date"
                name="effective_from"
                value={formData.effective_from}
                onChange={onInputChange}
                required
                className="input-clay"
              />
            </div>
            <div>
              <label htmlFor="pricing-input-cost" className="block text-sm font-medium text-body-text mb-1">Input Cost per 1M Tokens ($)</label>
              <input
                id="pricing-input-cost"
                type="number"
                name="input_cost_per_1m"
                value={formData.input_cost_per_1m}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="e.g., 0.15"
                className="input-clay"
              />
            </div>
            <div>
              <label htmlFor="pricing-output-cost" className="block text-sm font-medium text-body-text mb-1">Output Cost per 1M Tokens ($)</label>
              <input
                id="pricing-output-cost"
                type="number"
                name="output_cost_per_1m"
                value={formData.output_cost_per_1m}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="e.g., 0.60"
                className="input-clay"
              />
            </div>
            <div>
              <label htmlFor="pricing-per-request-cost" className="block text-sm font-medium text-body-text mb-1">Per Request Cost ($)</label>
              <input
                id="pricing-per-request-cost"
                type="number"
                name="per_request_cost"
                value={formData.per_request_cost}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="For non-token pricing"
                className="input-clay"
              />
            </div>
          </div>
          <div className="mt-4 flex space-x-3">
            <button
              type="submit"
              disabled={saving}
              className="btn-clay"
            >
              {saving ? 'Saving...' : (editingId ? 'Update' : 'Create')}
            </button>
            <button
              type="button"
              onClick={onReset}
              className="btn-clay-ghost"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    )}
  </>
);

export default PricingForm;
